import { ChangeEvent, useCallback } from 'react';
import { Switch } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import FrequencySelector from 'components/widgets/ProjectGroupEdit/NotificationSettings/FrequencySelector';
import { useDashboardGroupNotifcations, useEmailFrequency } from 'state/dashboard';
import { EmailFrequency } from 'types';

// Styles
const sectionParent = { flexWrap: 'wrap', width: '100%' };

const radioContainer = {
  gap: 'padding_8',
  flexWrap: 'wrap',
  justifyContent: 'start',
  width: '100%',
};

const checkBoxes = {
  '.chakra-switch__track': {
    width: '38px',
    height: '24px',
  },
  '.chakra-switch__thumb': {
    width: '24px',
    height: '24px',
  },
  '& .chakra-switch__track[data-checked]': {
    bg: Colors.ForestGreen900,
  },
};

const NotificationSettings = ({ showTitle = true }: { showTitle?: boolean }) => {
  const [notifications, setNotifications] = useDashboardGroupNotifcations();
  const [emailFrequency, setEmailFrequency] = useEmailFrequency();

  const onToggleNotification = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setNotifications((prev) => ({
        ...prev,
        enabled: Boolean(e.target.checked),
      }));
    },
    [setNotifications],
  );

  const handleFrequencyChange = useCallback(
    (newFrequency: EmailFrequency) => {
      setEmailFrequency(newFrequency);
    },
    [setEmailFrequency],
  );

  return (
    <FlexRow sx={sectionParent}>
      <FlexColumn sx={radioContainer}>
        {showTitle ? (
          <FlexRow
            sx={{ alignItems: 'center', gap: 'padding_8', marginBottom: 'padding_8' }}
          >
            <Text.BodyBold>Email Notifications</Text.BodyBold>
            <Switch
              isChecked={notifications.enabled}
              onChange={onToggleNotification}
              sx={checkBoxes}
            />
          </FlexRow>
        ) : (
          <Switch
            isChecked={notifications.enabled}
            onChange={onToggleNotification}
            sx={checkBoxes}
          />
        )}

        {notifications.enabled && (
          <FrequencySelector
            emailFrequency={emailFrequency}
            handleFrequencyChange={handleFrequencyChange}
          />
        )}
      </FlexColumn>
    </FlexRow>
  );
};

export default NotificationSettings;
